import React, { useEffect, useState } from "react";
import { Card, Col, Form, Row, Image, FloatingLabel } from "react-bootstrap";
import { usePlannerContext } from "../../../contexts/planner.contexts";

const TspForm = ({ validated, submit }) => {
  const {
    plannerData,
    onChangeHandler,
    handleBlur,
    handleKeyPress,
    handleFocus,
  } = usePlannerContext();

  const [formData, setformData] = useState({});

  useEffect(() => {
    if (
      plannerData &&
      typeof plannerData === "object" &&
      Object.keys(plannerData).length > 0
    ) {
      setformData(plannerData);
    }
  }, [plannerData]);
  const submitFormdata = (event) => {
    submit(event, formData);
  };
  return (
    <>
      <Card.Body className="fegli-section2 tspForm-section">
        <Form
          name="tspForm"
          onSubmit={submitFormdata}
          className="employee-form"
          noValidate
          validated={validated}
        >
          <div className="text-center">
            <div className="head-title">THRIFT SAVINGS PLAN (TSP)</div>
          </div>

          <Row>
            <Col md={6}>
              <div className="sub-title">
                <p className="mb-2">
                  The Thrift Savings Plan (TSP) is a retirement savings plan for
                  federal employees, similar to the savings and tax benefits of
                  a 401(k) offered to employees in the private sector. Congress
                  established the TSP in the Federal Employees' Retirement
                  System Act of 1986 to provide retirement income for federal
                  employees.
                </p>
              </div>
              <div className="section-head">EMPLOYER MATCHES</div>
              <table className="section-table">
                <tbody>
                  <tr>
                    <td style={{ textAlign: "left" }}></td>
                    <td>FERS</td>
                    <td>CSRS</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "left" }}>
                      1%-3% of basic pay are matched
                    </td>

                    <td>100%</td>
                    <td>0%</td>
                  </tr>
                  <tr>
                    <td
                      style={{ textAlign: "left", borderBottom: "1px solid " }}
                    >
                      4%-5% of basic pay are matched
                    </td>
                    <td style={{ borderBottom: "1px solid " }}>50%</td>
                    <td style={{ borderBottom: "1px solid " }}>0%</td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "left" }}>6% +</td>
                    <td>0%</td>
                    <td>0%</td>
                  </tr>
                </tbody>
              </table>
              <div className="mt-2">
                <div className="section-head">TSP TRADITIONAL BASICS</div>
                <ul
                  style={{
                    fontSize: "14px",
                    listStyleType: "disc",
                    marginBottom: "15px",
                  }}
                >
                  <li>Not taxed today. Pay tax when money is withdrawn.</li>
                  <li>Taxed on growth and interest accumulated.</li>
                </ul>
              </div>
              <div className="mt-2">
                <div className="section-head">TSP ROTH BASICS</div>
                <ul
                  style={{
                    fontSize: "14px",
                    listStyleType: "disc",
                    marginBottom: "15px",
                  }}
                >
                  <li>
                    Taxed today. Not taxable when money is withdrawn, assuming
                    the first Roth contribution was made at least 5 years
                    earlier AND you have attained the age of 59 ½.
                  </li>
                </ul>
              </div>
              <div>
                <p style={{ fontSize: "14px" }}>
                  <b>NOTE: Roth and Traditional payroll contributions</b> are
                  both included in payroll tax calculations (e.g., Social
                  Security taxes).
                </p>
              </div>
              <div className="mt-2">
                <div className="section-head">INVESTMENT OF TSP ACCOUNTS</div>
                <div className="sub-title">
                  <p>
                    There are six investment funds for TSP accounts, the G Fund,
                    C Fund, F Fund, S Fund, I Fund and the Lifecycle funds, L
                    Fund. All employees may elect to invest any portion of their
                    current account balances and/or future contributions between
                    the funds in any way they choose. You will not be protected
                    by either the U.S. Government or the Federal Retirement
                    Thrift Investment board against investment loss in the
                    Funds, nor do they guarantee a return on your investment.
                  </p>
                </div>
              </div>
              <div className="mt-2">
                <div className="section-head">FUND MANAGEMENT</div>
                <div className="semi-title">G Fund</div>
                <div className="sub-title">
                  <p>
                    The G Fund assets are managed internally by the Federal
                    Retirement Thrift Investment Board. The G Fund buys a
                    nonmarketable U.S. Treasury security that is guaranteed by
                    the U.S. Government. This means that the G Fund will not
                    lose money. The F, C, S, and I Funds are index funds, each
                    of which is invested in order to replicate the risk and
                    return characteristics of its appropriate benchmark index as
                    follows:
                  </p>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div>
                <ul
                  style={{
                    fontSize: "14px",
                    fontStyle: "italic",
                    listStyleType: "disc",
                    marginBottom: "15px",
                    marginTop: "15px",
                  }}
                >
                  <li>
                    The F Fund's objective is to match the performance of the
                    Barclays Capital U.S. Aggregate Bond Index.
                  </li>
                  <li>
                    The C Fund's objective is to match the performance of the
                    Standard & Poor’s 500 (S&P 500) Index.
                  </li>
                  <li>
                    The S Fund's objective is to match the performance of the
                    Dow Jones U.S. Completion TSM Index.
                  </li>
                  <li>
                    The I Fund’s investment objective is to match the
                    performance of the MSCI ACWI IMI ex USA ex China ex Hong
                    Kong Index.
                  </li>
                </ul>
              </div>
              <div>
                <div className="semi-title">L Fund</div>
                <div className="sub-title">
                  <p>
                    The L Funds are invested in the five individual TSP funds
                    based on professionally determined asset allocations. The
                    objective of the L Fund is to provide professionally
                    diversified portfolios based on various time horizons, using
                    the G, F, C, S, and I Funds.
                  </p>
                </div>
              </div>
              <div className="mt-2">
                <div className="section-head">ACCESSING INFORMATION</div>
                <div className="sub-title">
                  <p>
                    The Thrift-Line is an automated telephone service for
                    participants which provides current account information 24
                    hours a day, 7 days a week. The Thrift-Line is 877-968-3778.
                    You will need to know your PIN and S.S. number. Also
                    accessible online through TSP website: www.tsp.gov
                  </p>
                </div>
              </div>
              <div className="mt-3">
                <div className="sub-title">
                  <p>
                    You can use the Thrift-Line or the TSP Website for the
                    following:
                  </p>
                </div>
                <ul
                  style={{
                    fontSize: "14px",
                    listStyleType: "disc",
                    marginBottom: "15px",
                  }}
                >
                  <li>Account balance. (Total you have in each fund.)</li>
                  <li>Interfund transfer request.</li>
                  <li>Loan information. (Status of a loan.)</li>
                  <li>Status of a withdrawal.</li>
                  <li>Most recent rates of return on the various Funds.</li>
                  <li>Change your Personal Identification Number (PIN)</li>
                </ul>
              </div>
              <div>
                <div className="section-head">EMERGENCY FUNDS</div>
                <div>
                  <ul style={{ fontSize: "14px", listStyleType: "disc" }}>
                    <li>
                      TSP ROTH and Traditional Accounts are great accumulation
                      vehicles for retirement planning.
                    </li>
                    <li>Emergency access during your career is limited.</li>
                  </ul>
                </div>
              </div>
            </Col>
          </Row>
          <div className="mt-2">
            <div className="textbox-wrapper">
              <select
                name="lite_last_time_looked_at_tsp_account"
                value={formData.lite_last_time_looked_at_tsp_account}
                className={
                  formData.lite_last_time_looked_at_tsp_account && "has-val"
                }
                onChange={(event) => onChangeHandler(event, setformData)}
              >
                <option value=""></option>
                <option value="Within past year">Within past year</option>
                <option value="Within past 5 years">Within past 5 years</option>
                <option value="More than 5 years ago">
                  More than 5 years ago
                </option>
                <option value="I'm not sure">I'm not sure</option>
              </select>

              <div className="floating-placeholder">
                When was the last time you looked at your TSP account?
              </div>
            </div>
          </div>
          <div className="mt-2">
            <FloatingLabel
              controlId="floatingInput"
              label="TSP Account Balance"
              className="my-3"
            >
              <Form.Control
                autoComplete="off"
                className="tsp-2-textbox  required-input"
                type="text"
                name="tsp_s2_balance"
                placeholder="TSP Account Balance"
                value={formData.tsp_s2_balance}
                onBlur={(e) => handleBlur(e, true, setformData)}
                onKeyPress={(e) => handleKeyPress(e)}
                onFocus={(event) => handleFocus(event, setformData)}
                onChange={(event) => onChangeHandler(event, setformData)}
                isInvalid={validated && !formData.tsp_s2_balance}
                required
              />
            </FloatingLabel>
          </div>

          <Row>
            <Col md={6}>
              <div>
                <div className="section-head">TSP LOAN PROGRAM</div>
                <p
                  style={{
                    fontStyle: "italic",
                    fontWeight: "700",
                    fontSize: "14px",
                  }}
                >
                  Eligibility
                </p>
                <div>
                  <ul
                    style={{
                      fontSize: "14px",

                      listStyleType: "disc",
                      marginBottom: "15px",
                    }}
                  >
                    <li>Current employee in a pay status.</li>
                    <li>
                      TSP account must have at least $1,000 In employee
                      contributions and associated earnings.
                    </li>
                    <li>
                      Loan balance must be within limits of federal tax law.
                    </li>
                    <li>
                      Amount left in paycheck after loan payment and other
                      deductions must equal at least 10% of basic pay.
                    </li>
                    <li>
                      Must document expenses for the allowed purposes (described
                      below) or demonstrate financial hardship.
                    </li>
                    <li>
                      {" "}
                      <b>FERS</b> employees must get spousal consent.
                    </li>
                    <li>
                      The loan Interest rate is the G Fund rate on the date the
                      application is processed.
                    </li>
                  </ul>
                </div>
              </div>
              <div>
                <div className="section-head">TSP ROTH VS ROTH IRA</div>

                <div>
                  <ul
                    style={{
                      fontSize: "14px",

                      listStyleType: "disc",
                      marginBottom: "15px",
                    }}
                  >
                    <li>
                      <b>TSP</b> Traditional - Not taxed today and pay tax when
                      money is withdrawn.
                    </li>
                    <li>
                      Emergency Access during your career is limited to hardship
                      withdrawal and TSP Loan.
                    </li>
                    <li>
                      Five year restriction to withdrawing ROTH TSP funds
                      without penalty
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <div>
                <p
                  style={{
                    fontWeight: "700",
                    fontStyle: "italic",
                    fontSize: "14px",
                  }}
                >
                  Purposes
                </p>
              </div>
              <div>
                <ul
                  style={{
                    fontSize: "14px",
                    listStyleType: "disc",
                    marginBottom: "15px",
                  }}
                >
                  <li>
                    <b className="purpose-b">
                      Purchase of a Primary Residence -
                    </b>{" "}
                    Primary residence includes a house, condominium, townhouse,
                    or mobile home which is not used on a transient basis.
                  </li>
                  <li>
                    <b className="purpose-b">General Purpose Loans -</b>
                    Loans are available for any purpose according to plan
                    guidelines. You may have one general loan and one
                    residential loan from your TSP account at any one time.
                  </li>
                  <li>
                    <b className="purpose-b">Financial hardship -</b>
                    participants may also qualify for a hardship loan.
                  </li>
                </ul>
              </div>
              <div>
                <p
                  style={{
                    fontWeight: "700",
                    fontStyle: "italic",
                    fontSize: "14px",
                  }}
                >
                  Terms of Loan
                </p>
              </div>
              <div>
                <ul
                  style={{
                    fontSize: "14px",

                    listStyleType: "disc",
                    marginBottom: "15px",
                  }}
                >
                  <li>Residential is 1 to 15 years</li>
                  <li>General Purpose is 1 to 5 years</li>
                </ul>
              </div>
            </Col>
          </Row>
          {validated && (
            <div className="red-text text-center mt-2">
              *Complete required fields to continue
            </div>
          )}
          <div className="btn-wrapper">
            <div className="text-center mt-4">
              <button className="btn-next btn question-next" type="submit">
                CONTINUE
              </button>
            </div>
          </div>
        </Form>
      </Card.Body>
    </>
  );
};

export default TspForm;
